<template>
  <div>
    <PageHeader title="er is iets misgegaan" />
    <div class="flex-grid align-center">
      <div class="card card-form">
        <Alert />
      </div>
    </div>
    <div class="content-image">
      <img
        src="../isaluAssets/img/png/login.png"
        alt
      >
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Alert from "@/components/ComponentAlert";
import PageHeader from "@/components/ComponentPageHeader";

export default {
  components: {
    Alert,
    PageHeader
  },
  methods: {
    ...mapActions(["confirm"])
  }
};
</script>
<style scoped>
.content-image {
  position: absolute;
  bottom: -10px;
  right: 0;
}
</style>
